import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';

export function formatMonthAndDay(date: string): string {
  const parsedDate = new Date(date);
  return format(parsedDate, 'dd LLL.', { locale: ptBR });
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleString('pt-BR').split(' ')[0].replace(',', '');
}

const getCurrentDate = () => {
  const currentDate = new Date();
  return new Date(currentDate.getTime() - (180 - currentDate.getTimezoneOffset()) * 60 * 1000);
};

export const getWeekName = (day: number) => {
  const name = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Sexta-feira', 'Sábado'];
  return name[day] ?? '';
};

const getDateByMilliseconds = (milliseconds: number) => {
  const seconds = Math.floor(milliseconds / 1000) || null;
  const minutes = Math.floor(seconds / 60) || null;
  const hours = Math.floor(minutes / 60) || null;
  const days = Math.floor(hours / 24) || null;

  return {
    seconds,
    minutes,
    hours,
    days
  };
};

export const getTime = (date: string) => {
  const dateInstance = new Date(date);
  const currentDate = getCurrentDate();

  const milliseconds = Math.abs(currentDate.getTime() - dateInstance.getTime());
  const { seconds, minutes, hours, days } = getDateByMilliseconds(milliseconds);

  if (days > 6) return formatDate(date);
  else if (days > 1) return getWeekName(dateInstance.getDay());
  else if (days === 1) return 'Ontem';

  if (hours) {
    return `${hours} Hora${hours > 1 ? 's' : ''} atrás`;
  }

  if (minutes) {
    return `${minutes} Minuto${minutes > 1 ? 's' : ''} atrás`;
  }

  if (seconds > 10) {
    return `${seconds} Segundo${seconds > 1 ? 's' : ''} atrás`;
  }

  return 'Agora';
};
